import { buildPeriodsToShow, getPeriodTypeFromScheduleType } from "./PeriodHelpers";

export const mapPeriods = (scheduleType, scheduleStructureData) => {
  const period_type = getPeriodTypeFromScheduleType(scheduleType, {
    // Constraints table should keep a single set of course periods for alternating schedules.
    alternating_uses_day_course_periods: false,
  });

  return buildPeriodsToShow(scheduleStructureData, {
    period_type,
    current_day: "1",
    natural_sort_course_periods: true,
  });
};

export const mapCoursePeriodSectionsSortedByQuarter = (data_sections) => {
  return data_sections.sort((section_A, section_B) => {
    const section_A_min_quarter = section_A.quarter_days.reduce(
      (result, quarter_day) => {
        if (quarter_day.quarter < result) result = quarter_day.quarter;
        return result;
      },
      "999"
    );
    const section_B_min_quarter = section_B.quarter_days.reduce(
      (result, quarter_day) => {
        if (quarter_day.quarter < result) result = quarter_day.quarter;
        return result;
      },
      "999"
    );
    if (section_A_min_quarter < section_B_min_quarter) return -1;
    return 1;
  });
};
